/**
 * @name SpanishTranslations
 * @description Traducciones en español
 */

export const SpanishTranslations = {
  // *************************************
  // GenericMessages                    
  // *************************************
  GenericMessages: {
    es: 'Español',
    en: 'English',
    pt: 'Português',
    app: 'Aplicación',
    apps: 'Aplicaciones',
    sidebar: 'Menú lateral',
    loading: 'Cargando',
    company: 'Empresa',
    rows: 'Filas',
    columns: 'Columnas',
    photo: 'Foto',
    name: 'Nombre',
    names: 'Nombres',
    lastName: 'Apellido',
    lastNames: 'Apellidos',
    job: 'Puesto',
    jobs: 'Puestos',
    area: 'Área',
    areas: 'Áreas',
    branch: 'Sucursal',
    branches: 'Sucursales',
    supervisor: 'Supervisor',
    supervisors: 'Supervisores',
    level: 'Nivel',
    levels: 'Niveles',
    levelDescription: 'Descripción de nivel',
    competence: 'Competencia',
    competencies: 'Competencias',
    gender: 'Género',
    age: 'Edad',
    male: 'Masculino',
    female: 'Femenino',
    scale: 'Escala',
    day: 'Día',
    days: 'Dias',
    week: 'Semana',
    weeks: 'Semanas',
    month: 'Mes',
    months: 'Meses',
    year: 'Año',
    years: 'Años',
    daily: 'Diario',
    weekly: 'Semanal',
    biweekly: 'Quincenal',
    monthly: 'Mensual',
    bimonthly: 'Bimestral',
    quarterly: 'Trimestral',
    biyearly: 'Semestral',
    annually: 'Anual',
    date: 'Fecha',
    dates: 'Fechas',
    birthDate: 'Fecha de nacimiento',
    startDate: 'Fecha de inicio',
    endDate: 'Fecha de fin',
    dueDate: 'Fecha de vencimiento',
    commitmentDate: 'Fecha de compromiso',
    creationDate: 'Fecha de creación',
    expirationDate: 'Fecha de caducidad',
    registrationDate: 'Fecha de registro',
    lastUpdateDate: 'Fecha de última actualización',
    lastUpdate: 'Última actualización',
    startTime: 'Hora de inicio',
    endTime: 'Hora de fin',
    start: 'Inicio',
    end: 'Fin',
    read: 'Leído',
    unread: 'No leído',
    clear: 'Borrar',
    open: 'Abrir',
    note: 'Nota',
    step: 'Paso',
    data: 'Datos',
    email: 'Email',
    academicLevel: 'Nivel académico',
    phone: 'Teléfono',
    civilStatus: 'Estado civil',
    seniority: 'Antigüedad',
    employee: 'Colaborador',
    employees: 'Colaboradores',
    employeeCode: 'Código de colaborador',
    employeeStatus: 'Estatus del colaborador',
    employeesOf: 'Colaboradores de',
    backup: 'Backup',
    backupOf: 'Backup de',
    option: 'Opción',
    options: 'Opciones',
    seeOptions: 'Más opciones',
    conversations: 'Conversaciones',
    survey: 'Sondeo',
    agenda: 'Agenda',
    catcher: 'Captura',
    admin: 'Administrador',
    adminOf: 'Administración de',
    of: 'de',
    to: 'a',
    or: 'o',
    and: 'y',
    toDate: 'al',
    from: 'Desde',
    until: 'Hasta',
    user: 'Usuario',
    users: 'Usuarios',
    userExternal: 'Usuario externo',
    team: 'Equipo',
    welcome: '¡Bienvenido!',
    welcomeTalentry: 'Bienvenido a Talentry',
    hello: '¡Hola',
    niceToHaveYouBack: 'Que gusto tenerte de nuevo en Talentry.',
    nextDelivery: 'Próxima entrega a vencer',
    nextDeliveryDate: 'Fecha de próxima entrega',
    earringsToRecognize: 'Pendientes por reconocer',
    pendingToRedeem: 'Pendientes por canjear',
    goTalentry: 'Ir a Talentry',
    error: 'Error',
    errros: 'Errores',
    noErrors: 'No se encontraron errores',
    noResults: 'No se encontraron registros',
    noResultsFoundSelectedFilters: 'No se encontraron registros con los filtros seleccionados',
    errorContactAdmin: 'Algo salió mal, comunícate con tu administrador.',
    userBlockedContactAdmin: 'Usuario bloqueado, favor de contactarte con el administrador.',
    languageUpdated: 'El idioma se actualizó correctamente.',
    responsibilities: 'Responsabilidades',
    respProgressTab: 'Avance de responsabilidades',
    free: 'Libre',
    everybody: 'Todos',
    nobody: 'Nadie',
    none: 'Ninguno',
    nonee: 'Ninguna',
    equal: 'Igual',
    notEqual: 'No igual',
    all: 'Todos',
    seeAll: 'Ver todos',
    seeDetail: 'Ver detalle',
    seeDetails: 'Ver detalles',
    seeMore: 'Ver más',
    copy: 'Copiar',
    search: 'Buscar',
    percentage: 'Porcentaje',
    average: 'Promedio',
    current: 'Actual',
    reply: 'Respuesta',
    progress: 'Avance',
    example: 'Ejemplo',
    examples: 'Ejemplos',
    duration: 'Duración',
    archive: 'Archivar',
    archived: 'Archivado',
    onTime: 'En tiempo',
    late: 'Tarde',
    total: 'Total',
    min: 'Mínimo',
    max: 'Máximo',
    chars: 'Caracteres',
    weight: 'Peso',
    sum: 'Suma',
    status: 'Estatus',
    detail: 'Detalle',
    details: 'Detalles',
    concept: 'Concepto',
    description: 'Descripción',
    localization: 'Localización',
    location: 'Ubicación',
    address: 'Dirección',
    city: 'Ciudad',
    state: 'Estado',
    country: 'País',
    private: 'Privado',
    comment: 'Comentario',
    comments: 'Comentarios',
    seeComment: 'Ver comentario',
    sendComment: 'Enviar comentario',
    confirmDeleteComment: '¿Estás seguro de eliminar tu comentario?',
    totalOfComments: 'Total de comentarios',
    filter: 'Filtro',
    filters: 'Filtros',
    filtered: 'Filtrados',
    byFilters: 'Por filtros',
    show: 'Mostrar',
    showing: 'Mostrando',
    register: 'Registro',
    registers: 'Registros',
    totalItems: 'Total de elementos',
    add: 'Añadir',
    edit: 'Editar',
    delete: 'Eliminar',
    deleted: 'Eliminado',
    select: 'Seleccionar',
    selectAll: 'Seleccionar todos',
    unselect: 'Deseleccionar',
    unselectAll: 'Deseleccionar todos',
    unselectSelected: 'Deseleccionar seleccionados',
    selected: 'Seleccionado',
    selecteds: 'Seleccionados',
    selectEmployees: 'Seleccionar colaboradores',
    selectedEmployees: 'Colaboradores seleccionados',
    item: 'Elemento',
    items: 'Elementos',
    noMatches: 'No se encontraron coincidencias',
    mandatory: 'Obligatorio',
    attachedImage: 'Imagen adjunta',
    attachedFile: 'Archivo adjunto',
    restore: 'Restaurar',
    undo: 'Deshacer',
    export: 'Exportar',
    import: 'Importar',
    download: 'Descargar',
    unableToDownload: 'No se ha podido realizar la descarga',
    successfulDownload: 'Se realizó la descarga con éxito',
    unfindFiles: 'No se encontraron archivos que descargar',
    timeWarning: 'La descarga podría tardar algunos minutos',
    nextPage: 'Página siguiente',
    previousPage: 'Página anterior',
    sendToAuth: 'Enviar a autorización',
    back: 'Atrás',
    next: 'Siguiente',
    exit: 'Salida',
    history: 'Historial',
    historical: 'Histórico',
    pendingPayment: 'Pago pendiente',
    paymentWarning: 'Aviso de vencimiento de licencia',
    noLicense: 'Tu licenciamiento en la nube presenta vencimiento, para evitar cualquier suspensión del servicio favor de contactar a tu administrador de Talentry.'
  },
  FormatDates: {
    short: 'DD/MM/YYYY',
    long: 'LL',
    birthday: 'DD/MM',
    shortDate: '{{date, DD/MM/YYYY}}',
    invalidDate: 'Ingresa una fecha válida',
    invalidMinDate: 'Ingresa una fecha válida. La fecha no debe ser anterior a la fecha mínima',
    invalidMaxDate: 'Ingresa una fecha válida. La fecha no debe ser despues a la fecha máxima',
  },
  StatusText: {
    yes: 'Sí',
    not: 'No',
    true: 'Alta',
    false: 'Baja',
    active: 'Activo',
    inactive: 'Inactivo',
    toBeApproved: 'Por aprobar',
    approved: 'Aprobado',
    rejected: 'Rechazado',
    notConcluded: 'No concluído',
    concluded: 'Concluído',
    inRevision: 'En revisión',
    awaiting: 'En espera',
    pending: 'Pendiente'
  },
  DialogConfirm: {
    approve: 'Aprobar',
    authorize: 'Autorizar',
    save: 'Guardar',
    send: 'Enviar',
    accept: 'Aceptar',
    confirm: 'Confirmar',
    continue: 'Continuar',
    cancel: 'Cancelar',
    close: 'Cerrar',
    reject: 'Rechazar',
    remove: 'Remover',
    understood: 'Entendido',
    finish: 'Finalizar',
  },
  HttpResponse: {
    error: '¡Error!',
    success: '¡Éxito!',
    unauthorized: 'Método no autorizado. Error 405',
    somethingWentWrong: 'Sucedió algo inesperado, inténtalo nuevamente por favor.',
    badRequest: 'Verifique todos los campos.'
  },
  FormsGeneralTexts: {
    required: 'Requerido',
    optional: 'Opcional',
    range: 'El rango permitido es entre',
    rangeLength: 'El límite de caracteres es entre',
    and: 'y',
    min2Chars: 'Debe contener 2 caracteres mínimo',
    min3Chars: 'Debe contener 3 caracteres mínimo',
    min4Chars: 'Debe contener 4 caracteres mínimo',
    min8Chars: 'Debe contener 8 caracteres mínimo',
    max20Chars: 'Debe contener 20 caracteres máximo',
    max25Chars: 'Debe contener 25 caracteres máximo',
    max100Chars: 'Debe contener 100 caracteres máximo',
    max250Chars: 'Debe contener 250 caracteres máximo',
    max500Chars: 'Debe contener 500 caracteres máximo',
    oneSymbol: 'Debe contener al menos un simbolo',
    oneDigit: 'Debe contener al menos un número',
    oneCapitalLetter: 'Debe contener al menos una letra mayúscula',
    oneLowerLetter: 'Debe contener al menos una letra minúscula',
    onlyDigits: 'Debe contener sólo dígitos del 0-9',
    valueCannotBeEqual: 'El valor no puede ser igual a',
    notMultipleSpaces: 'No debe contener multiples espacios'
  },
  // *************************************
  // Time                            
  // *************************************
  Time: {
    hour: 'Hora',
    hours: 'Horas',
    minute: 'Minuto',
    minutes: 'Minutos',
    second: 'Segundo',
    seconds: 'Segundos'
  },
  // *************************************
  // WeekDays                             
  // *************************************
  WeekDays: {
    monday: 'Lunes',
    tuesday: 'Martes',
    wednesday: 'Miércoles',
    thursday: 'Jueves',
    friday: 'Viernes',
    saturday: 'Sábado',
    sunday: 'Domingo'
  },
  WeekDaysShort: {
    monday: 'Lun',
    tuesday: 'Mar',
    wednesday: 'Mié',
    thursday: 'Jue',
    friday: 'Vie',
    saturday: 'Sáb',
    sunday: 'Dom'
  },
  // *************************************
  // Months                            
  // *************************************
  Months: {
    jan: 'Enero',
    feb: 'Febrero',
    mar: 'Marzo',
    apr: 'Abril',
    may: 'Mayo',
    jun: 'Junio',
    jul: 'Julio',
    aug: 'Agosto',
    sep: 'Septiembre',
    oct: 'Octubre',
    nov: 'Noviembre',
    dec: 'Diciembre',
  },
  MonthsShort: {
    jan: 'Ene',
    feb: 'Feb',
    mar: 'Mar',
    apr: 'Abr',
    may: 'May',
    jun: 'Jun',
    jul: 'Jul',
    aug: 'Ago',
    sep: 'Sep',
    oct: 'Oct',
    nov: 'Nov',
    dec: 'Dic',
  },
  // *************************************
  // Applications                     
  // *************************************
  Applications: {
    sysAdmin: 'sysAdmin',
    settings: 'Configuración',
    management: 'Administración',
    acknowledgements: 'Reconocimientos',
    indicators: 'Indicadores',
    indicatorsAccum: 'Indicadores Acumulados',
    evaluations: 'Evaluaciones',
    communication: 'Comunicación',
    academy: 'Academy',
    developmentPlan: 'Plan de Desarrollo'
  },
  // *************************************
  // Reports                             
  // *************************************
  Report: {
    report: 'Reporte',
    reports: 'Reportes',
    columns: 'Columnas',
    export: 'Exportar',
    exportToPNG: 'Exportar a PNG',
    exportToJPG: 'Exportar a JPG',
    exportToCsv: 'Exportar a CSV',
    exportToPdf: 'Exportar a PDF',
    exportToExcel: 'Exportar a Excel',
    exportAllToExcel: 'Exportar todo a Excel',
    exportFiltetredToExcel: 'Exportar filtrado a Excel',
    selectAReport: 'Selecciona un reporte.',
    selectExportOptions: 'Selecciona la opción que deseas exportar.',
    selectColumnsToShow: 'Selecciona las columnas que deseas mostrar o ocultar.'
  },
  // *************************************
  // Log In                             
  // *************************************
  Login: {
    sessionStart: 'Iniciar sesión',
    keepSess: 'No cerrar sesión',
    rememberDevice: 'Recordar este dispositivo',
    rememberDeviceHelp: 'Omite la verificación en este navegador durante el tiempo permitido.',
    enterLogIn: 'Ingresar',
    twoFactorTitle: 'Verificación en dos pasos',
    twoFactorPending: 'Tu cuenta requiere una verificación adicional para continuar.',
    twoFactorNextStep: 'En el siguiente paso podrás capturar tu código de verificación.',
    twoFactorSentTo: 'El código se enviará al correo registrado:',
    twoFactorChallengeId: 'Identificador de reto',
    backToCredentials: 'Volver a credenciales',
    twoFactorCode: 'Código de verificación',
    twoFactorCodeHelp: 'Ingresa el código de 6 dígitos que recibiste por correo.',
    twoFactorCodeRequired: 'El código es obligatorio.',
    twoFactorCodeInvalid: 'Ingresa un código válido de 6 dígitos.',
    twoFactorVerify: 'Verificar código',
    twoFactorVerifying: 'Verificando...',
    twoFactorResend: 'Reenviar código',
    twoFactorResending: 'Reenviando...',
    twoFactorResentSuccess: 'Se envió un nuevo código de verificación.',
    twoFactorVerifyError: 'No fue posible validar el código. Intenta de nuevo.',
    twoFactorRemainingAttempts: 'Código inválido. Intentos restantes: {{count}}.',
    twoFactorResendError: 'No fue posible reenviar el código. Intenta de nuevo.',
    twoFactorUnexpectedError: 'No fue posible continuar con la verificación en dos pasos.',
    twoFactorExpiresIn: 'El código vence en {{time}}.',
    twoFactorResendIn: 'Podrás reenviar el código en {{time}}.',
    twoFactorResendReady: 'Ya puedes reenviar el código.',
    twoFactorExpired: 'El código de verificación expiró. Vuelve a iniciar sesión.',
    forgotPassword: '¿Olvidaste tu contraseña?',
    userEnterpriseId: 'usuario.idempresa',
    password: 'Contraseña',
    sessionExpired: 'Se ha vencido la sesión.',
    sessionExtended: 'Sesión extendida con éxito.',
    sessionExpiringTitle: '¡Tu sesión está por expirar!',
    sessionExpiringBody: '¿Deseas continuar y extender tu sesión?',
    sessionOf: 'Sesión de',
    timeRemaining: 'Tiempo restante',
    closeSession: 'No, cerrar sesión',
    continueSession: 'Si, continuar sesión',
    extendingSession: 'Extendiendo sesión...',
  },
  // *************************************
  // Topbar                             
  // *************************************
  Topbar: {
    home: 'Inicio',
    goBack: 'Regresar',
    notification: 'Notificación',
    notifications: 'Notificaciones',
    notificationsCenter: 'Centro de notificaciones',
    noNotifications: 'Aún no tienes notificaciones',
    errorNotifications: 'No se cargaron las notificaciones',
    markAllAsRead: 'Marcar todas como leídas',
    noApps: 'Aún no tienes aplicaciones asignadas',
    adminMenu: 'Menú de administrador',
    userMenu: 'Menú de usuario',
    setting: 'Configuración',
    onboarding: 'Onboarding',
    logout: 'Cerrar sesión',
    language: 'Idioma',
  },
  // *************************************
  // ForgotPassword
  // *************************************
  ForgotPass: {
    retrievePassword: 'Recuperar contraseña',
    retrieveMSG: 'Si olvidaste tu contraseña y no puedes acceder a tu cuenta de Talentry introduce tu usuario, enseguida te llegará un mensaje a tu correo electrónico registrado para que puedas cambiar tu contraseña.',
    retrieve: 'Recuperar',
    procReq: 'Procesando tu petición...',
    invalidUser: 'Es necesario que escribas un usuario válido.',
  },
  // *************************************
  // ChangePassword
  // *************************************
  ChangePass: {
    changePass: 'Cambia tu contraseña',
    enterNewPass: 'Introduce tu nueva contraseña',
    configProcess: 'El proceso de configuración es rápido y sencillo, sólo debes crear tu contraseña para comenzar la aventura',
    passMustMeet: 'La contraseña debe cumplir con las siguientes características:',
    mustHaveSymDot: 'Debe contener por lo menos un caracter que no sea letra ni dígito, ejemplo punto(.), coma(,), guión(-), etc.',
    mustBetweenDigit0: 'Debe contener al menos un número entre 0 y 9.',
    mustHaveMin8Chars: 'Debe contener mínimo 8 caracteres.',
    atLeastCap: 'Debe contener al menos una letra mayúscula y una letra minúscula.',
    errorToChangePass: 'Para cambiar tu contraseña es necesario que solicites un cambio, posterior recibirás un correo electrónico al que es necesario hacer click.',
    previousPass: 'Contraseña anterior',
    newPass: 'Contraseña nueva',
    confirmPass: 'Confirmar contraseña',
    noPassMatch: 'Las contraseñas no coinciden',
  },
  // *************************************
  // UnlockUser
  // *************************************
  UnlockUser: {
    unlockAccount: 'Desbloqueo de cuenta',
    userUnlocked: '¡Usuario desbloqueado!',
    emailExpiredMSG: 'El correo ha expirado, para desbloquear tu cuenta es necesario que intentes ingresar nuevamente, posterior recibirás un nuevo correo electrónico al que es necesario hacer click.'
  },
  // *************************************
  // Footer
  // *************************************
  Footer: {
    allRightsReserved: 'Todos los derechos reservados.',
    noticePrivacy: 'Aviso de privacidad',
    termsUse: 'Términos de uso'
  },
  // *************************************
  // Home                            
  // *************************************
  Home: {
    mission: 'Misión',
    vision: 'Visión',
    values: 'Valores',
    goals: 'Objetivos',
    purpose: 'Propósito',
    principles: 'Principios',
    attributes: 'Promesa de marca',
    man: 'Hombres',
    woman: 'Mujeres',
    genderDemographics: 'Demografía de genero',
    anniversaries: 'Aniversarios laborales',
    anniversariesMonth: 'Aniversarios laborales en',
    noAnniversariesFound: 'No hay próximos aniversarios laborales en',
    birthdays: 'Cumpleaños',
    birthdaysMonth: 'Cumpleaños en',
    noBirthdaysFound: 'No hay próximos cumpleaños en',
    today: 'Hoy',
    tomorrow: 'Mañana',
    youExternalUser: 'Eres usuario externo'
  },
  // *************************************
  // News                            
  // *************************************
  News: {
    new: 'Aviso',
    news: 'Avisos',
    noNews: 'No hay avisos',
    seeAllNews: 'Ver todos los avisos',
    importantAnnouncements: 'Comunicados y anuncios importantes.',
    all: 'Todos',
    forAll: 'Es para todos',
    forSupervisor: 'Es para supervisor',
    title: 'Título',
    subject: 'Asunto',
    message: 'Mensaje',
    body: 'Cuerpo',
    noPastDates: 'Las fechas no deben ser anteriores al día de hoy y la fecha de vencimiento debe ser igual o posterior a la fecha de inicio',
    pastDates2: 'La fecha de vencimiento debe ser igual o posterior a la fecha de inicio',
    newsDeleteSuccess: 'Se eliminaron los avisos de forma correcta',
    newsDeleteError: 'Hubo un error al procesar la solicitud',
    addNews: 'Añadir aviso',
    editNews: 'Editar aviso',
    create: 'Crear',
    sendNews: 'Enviar aviso',
    sendEmail: 'Enviar correo',
    sendNotification: 'Enviar notificación',
    emailSettings: 'Configuración de correo',
    sendSettings: 'Configuración de envío',
  },
  // *************************************
  // Settings
  // *************************************
  Settings: {
    profileConfig: 'Configuración de perfil',
    personalData: 'Datos personales',
  },
  // *************************************
  // Responsibilities
  // *************************************
  Responsibilities: {
    responsibility: 'Responsabilidad',
    respReport: 'Aqui puedes descargar las responsabilidades de tu estructura.',
    noRespReport: 'Tu estructura aún no tiene responsabilidades.',
    structureResponsibilities: 'Responsabilidades de la estructura',
    configByEmployee: 'Configurar responsabilidades por colaborador',
    seeingMy: 'Estás viendo tus responsabilidades',
    seeingOf: 'Estás viendo las responsabilidades de',
    selectEmployeeResponsibilities: 'Selecciona un colaborador para ver sus responsabilidades',
    progressByEmployee: 'Avances por colaborador',
    toBeApproved: 'Por aprobar',
    revertStatus: 'Regresar estatus',
    revertStatusResp: 'Regresar estatus de responsabilidades',
    rejectResp: 'Rechazar responsabilidades',
    whyRevertingStatus: '¿Por qué se están regresando de estatus las responsabilidades?',
    whyRejectingStatus: '¿Por qué se están rechazando las responsabilidades?',
    minItemsIs: 'El mínimo de elementos es ',
    maxItemsIs: ', el máximo de elementos es ',
    weightTotal: ' y la suma de su peso debe ser 100',
    minRespIs: 'El mínimo de responsabilidades es ',
    maxRespIs: ', el máximo de elementos es ',
    sumRespWeight: ' y la suma de su peso debe ser 100',
    areaCode: 'Código de área'
  },
  // *************************************
  // UploadFile                    
  // *************************************
  UploadFile: {
    dragAndDrop: 'Arrastra y suelta tu archivo ',
    browseFile: 'o pulsa aquí para examinar tu equipo',
    attachFile: 'Adjuntar archivo',
    attachedImage: 'Imagen adjunta',
    attachedFile: 'Archivo adjunto',
    downloadFile: 'Descargar archivo adjunto',
    deleteFile: 'Eliminar archivo adjunto',
    restoreFile: 'Restaurar archivo adjunto',
    file: 'Archivo',
    files: 'Archivos',
    image: 'Imagen',
    images: 'Imágenes',
    format: 'Formato',
    aspectRatio: 'Relación de aspecto',
    messageFileRejected: 'El archivo {{fileName}} fue rechazado. ',
    messageFileTooBig: 'El archivo es demasiado grande. El límite de tamaño es de {{maxSize}} MB. ',
    messageInvalidType: 'Tipo de archivo no admitido. ',
    messageAddedFile: 'El archivo {{fileName}} se ha agregado exitosamente. ',
    messageRemovedFile: 'El archivo {{fileName}} se ha eliminado. '
  },
  // *************************************
  // Massive Uploads                             
  // *************************************
  MassiveUploads: {
    downloadBaseFile: 'Descargar archivo base vacío',
    descriptionError: 'Descripción del error',
    successUpload: 'Los registros de la carga masiva, se insertaron correctamente.',
    errorUpload: 'Existen errores en algunos registros en la carga masiva.',
    uploadZIPFileMessage: 'El nombre de cada archivo a cargar dentro del ZIP debe de ser similar al siguiente ejemplo'
  },
  // *************************************
  // Shedule                            
  // *************************************
  Shedule: {
    checkIn: 'Hora de entrada',
    departure: 'Hora de salida',
    entryHours: 'Horario entrada',
    departureTime: 'Horario salida',
    workdays: 'Días laborables',
    lookingYouShedule: 'Estas viendo tu horario',
    lookingAtShedule: 'Estas viendo el horario de',
    scheduleSetting: 'Configuración de horario',
    scheduleReview: 'Revisión de horario',
    whyApproveSchedule: '¿Por qué se está aprobando el horario?',
    whyRejectingSchedule: '¿Por qué se está rechazando el horario?',
    rejectSchedule: 'Rechazar horario',
    approveSchedule: 'Aprobar horario',
  },
  // *************************************
  // Backup                            
  // *************************************
  BackupSettings: {
    assignBackup: 'Asignar backup',
    backupAssignments: 'Asignaciones de backup',
    periodApply: '¿En qué periodo aplicará?',
    whoYourBackup: '¿Quién será tu Backup?',
    warningBackup: 'Nota: el backup se utiliza únicamente para el módulo de Centro de ayuda',
    sureCancelBackup: '¿Estás seguro de que deseas cancelar esta asignación de backup?',
    sureRejectBackup: '¿Estás seguro de que deseas rechazar esta asignación de backup?',
    commentCancelBackup: 'Escribe un comentario para la cancelación de este backup:',
    commentRejectBackup: 'Escribe un comentario para el colaborador que te seleccionó:',
    cancelBackup: 'Cancelar backup',
    rejectBackup: 'Rechazar backup',
    infoAlreadyCancel: 'No es posible cancelar esta asignación de backup debido a que ya esta cancelado.',
    infoNotPossibleCancel: 'No es posible cancelar esta asignación de backup.',
    infoNotPossibleCancelStartDate: 'No es posible cancelar esta asignación de backup debido a que ya ha pasado la fecha de inicio.',
    infoAlreadyReject: 'No es posible rechazar esta asignación de backup debido a que ya esta rechazado.',
    infoNotPossibleReject: 'No es posible rechazar esta asignación de backup.',
    infoNotPossibleRejectTomorrow: 'No es posible rechazar esta asignación de backup debido a que la fecha de inicio es el día de mañana.',
    backupLog: 'Bitácora de Backup',
    catalogResp1: 'Aprobar / Autorizar planes de indicadores',
    catalogResp2: 'Registrar resultados de indicadores',
    catalogResp3: 'Aprobar / Autorizar indicadores acumulados',
    catalogResp4: 'Realizó una actualización',
    catalogResp5: 'Atender/Resolver solicitudes en Centro de ayuda',
    requestDescription: 'Descripción de la solicitud',
    aplicantBackup: 'Solicitante',
    respToDelegate: '¿Qué responsabilidades delegarás?',
    hasNotResp: 'no tiene responsabilidades que delegar',
    respIndicatorsBackup: 'Responsabilidades de Indicadores',
    respHelpDeskBackup: 'Responsabilidades de Centro de Ayuda',
    confirmed: 'Confirmado',
    rejected: 'Rechazado',
    cancelled: 'Cancelado',
    finalized: 'Finalizado',
    createdBackup: 'Creó una solicitud de backup',
    rejectedBackup: 'Rechazó la solicitud de backup',
    canceledBackup: 'Canceló la solicitu de backup',
    madeBackup: 'Realizó una actualización',
  },
  // *************************************
  // Request Job                            
  // *************************************
  Request: {
    actualJob: 'Puesto actual',
    requiredJob: 'Puesto solicitado',
    jobChange: 'Cambio de puesto',
    lookingYouRequest: 'Estás viendo tus solicitudes',
    lookingAtRequest: 'Estás viendo las solicitudes de',
    requestReview: 'Revisión de cambio de puesto',
    whyApproveRequest: '¿Por que apruebas la solicitud?',
    whyRejectingRequest: '¿Por que rechazas la solicitud?',
    rejectRequest: 'Rechazar solicitud',
    approveRequest: 'Aprobar solicitud',
    selectnewJob: 'Selecciona tu nuevo puesto',
    warningRequest: 'Al cambiar el puesto de un colaborador, si el nuevo puesto tiene una duración diferente a su periodo actual, el periodo actual se verá truncado y se generarán periodos mensuales hasta alcanzar el inicio del periodo que corresponde al puesto por el cual se realizará el cambio.'
  },
  // *************************************
  // Notifications                     
  // *************************************
  Notifications: {
    // Gral. Talentry
    adminResponsibilitiesToActive: 'Tu administrador cambió el estatus de tus responsabilidades a activo',
    adminResponsibilitiesApproved: 'Tu administrador ha aprobado tus responsabilidades',
    adminResponsibilitiesRejected: 'Tu administrador ha rechazado tus responsabilidades',
    supervisorResponsibilitiesToActive: 'Tu supervisor cambió el estatus de tus responsabilidades a activo',
    supervisorResponsibilitiesApproved: 'Tu supervisor ha aprobado tus responsabilidades',
    supervisorResponsibilitiesRejected: 'Tu supervisor ha rechazado tus responsabilidades',
    responsibilitiesToApprove: 'Tienes responsabilidades pendientes por aprobar de <colaborador>',
    birthdayReminder: 'Te informamos que en <dias> día(s) será el cumpleaños de <colaborador>',
    evaluationParticipant: 'Te informamos que has sido elegido para participar en la evaluación <evaluacion>',
    shedulePendingToSend: 'Tienes el horario pendiente de configurar y de enviar a aprobación.',

    // Indicadores
    assignedResultsManager: 'Te han asignado como encargado de resultados de un <tipoMetrica> del catálogo',
    suggestedIndicators: '<colaborador> te ha sugerido un indicador del catálogo',
    periodPlanApproved: 'Tu plan de <periodo> ha sido aprobado por <colaborador>',
    periodPlanRejected: 'Tu plan de <periodo> ha sido rechazado por <colaborador>',
    periodResultsAuthorized: 'Tus resultados de <periodo> han sido autorizados por <colaborador>',
    periodResultsRejected: 'Tus resultados de <periodo> han sido rechazados por <colaborador>',
    periodPenalizedBySupervisor: 'Tu plan de <periodo> ha sido penalizado con el <porcentaje>% por <colaborador>',
    pendingPlansApprove: 'Tienes planes pendientes por aprobar',
    pendingResultsAuthorize: 'Tienes resultados pendientes por autorizar',
    assignedAsBackup: 'Te han asignado como backup de <colaborador> del <fechaInicio> al <fechaFin>',
    newBackupAssignments: 'Hay nuevas asignaciones de Backup',
    adminCancelled: 'El administrador ha cancelado tu asignación de backup',
    backupRejected: '<colaborador> ha rechazado tu asignación de backup',
    newIndicatorsCatalogAdded: 'Se añadieron indicadores al catálogo',
    backupPeriodEnded: 'Tu periodo de backup ha finalizado',
    reminderSendPlan: 'Tienes hasta el <fecha> para enviar tu plan de indicadores de <periodo>',
    reminderSendResults: 'Tienes hasta el <fecha> para enviar tus resultados de <periodo>',
    reminderSendPlanPeriods: 'Tienes hasta el <fecha> para enviar tu plan de indicadores de <periodo> - <periodoFin>',
    resultIndicatorCaptured: 'El resultado de un indicador del catálogo que tienes en tu plan de <periodo> ha sido capturado',
    resultModificated: 'El resultado de un indicador del catálogo que tienes en tu plan de <periodo> ha sido modificado',

    // Reconocimientos
    pendingPrizeRedeptions: 'Tienes canjes pendientes por registrar del premio <premio>',
    assignedKeeperPrizeBranch: 'Te han asignado como responsable del premio <premio> en la sucursal <sucursal>',
    assignedKeeperPrize: 'Te han asignado como responsable del premio <premio>',
    assignedKeeperDeliveryPrizes: 'Te han asignado como responsable de entrega de premios',
    acknowledgementsToAcknowledge: 'Has recibido <reconocimiento> para reconocer',
    timeToAcknowledge: '¡Es momento de reconocer!',
    acknowledgementsToRedeem: 'Te han asignado <reconocimiento> para canjear',
    congratulationsAcknowledgements: '¡Felicidades! <colaborador> te ha regalado un <reconocimiento>',
    respondAcknowledgements: '<colaborador> te ha respondido el reconocimiento que le hiciste',
    redeptionCancelled: 'Tu canje por el premio <premio> ha sido cancelado',
    deliveryCancelled: 'Tu <reconocimiento> para <colaborador> ha sido cancelado',
    deliveryReceivedCancelled: 'Tu <reconocimiento> recibido de <colaborador> ha sido cancelado',

    // Evaluaciones
    chooseFriendsEvaluation: 'Ahora puedes elegir a tus amigos en la evaluación <evento>',
    chosenAsFriendEvaluation: 'Has sido elegido como amigo de <colaborador> en la evaluación <evento>',
    checkResultsEvaluation: 'Revisa los resultados de la evaluación <evento>',
    timeToEvaluate: '¡Es momento de evaluar!',
    notFinishEvaluate: '¡Aún no terminas de evaluar!',
    makeActionPlan: 'Aún no tienes vinculada ninguna actividad a la evaluación <evaluacion>, te invitamos a trabajar en tu plan de acción',

    // Indicadores Acumulados
    accumulatedIndicatorApproved: 'Tu indicador acumulado ha sido aprobado',
    accumulatedIndicatorRejected: 'Tu indicador acumulado ha sido rechazado',
    advancesAccumulatedIndicatorApproved: 'Tus avances de tu indicador acumulado han sido autorizados',
    advancesAccumulatedIndicatorRejected: 'Tus avances de tu indicador acumulado han sido rechazados',
    pendingAccumulatedIndicators: 'Tienes indicadores acumulados de tu equipo pendientes de revisar',
    pendingAdvancesAccumulatedIndicators: 'Tienes avances de indicadores acumulados de tu equipo pendientes de revisar',

    // Plan de Desarrollo
    activitiesToApprove: 'Tienes actividades pendientes por aprobar',
    activityApproved: 'Tu actividad de tipo <actividad> ha sido autorizado',
    activityRejected: 'Tu actividad de tipo <actividad> ha sido rechazado',
    suggestionsActivities: '<colaborador> te ha hecho una sugerencia para tu plan de desarrollo',
    suggestionReceived: '<colaborador> te ha sugerido añadir una actividad de tipo <actividad> a tu plan de desarrollo',
    makeDevelopmentPlan: 'Aún no tienes vinculada ninguna actividad a la evaluación <evaluacion>, te invitamos a trabajar en tu plan de desarrollo',
    haveBeenAssignedTrainingPath: 'Te han asignado el path de capacitación: <path>',
    trainingPathHasBeenModified: 'El path de capacitación <path> fue modificado',
    commitmentDateCloseExpirationActiviy: 'La fecha compromiso de la actividad <actividad>, esta próxima a llegar',
    endDateCloseExpirationActiviy: 'La fecha fin de la actividad <actividad>, esta próxima a llegar',
    generalDevelopmentPlanProgressReminder: 'Recuerda trabajar en tu plan de desarrollo y registrar avances',
    activityDevelopmentPlanProgressReminder: 'Recuerda trabajar en tus <actividad> y registrar avances',

    // Academy
    adminEnrolledToCourse: 'El administrador de Academy te ha inscrito al curso <curso>',
    adminSentToWaitingList: 'El administrador de Academy te envió a la lista de espera del curso <curso>',
    concludeCourse: 'Te felicitamos por concluir el curso <curso>',
    scheduleModified: 'La calendarización del curso <curso> ha sido modificada',
    scheduleCancelled: 'La calendarización del curso <curso> ha sido cancelada',
    requestsToReview: 'Tienes solicitudes de cursos pendientes por revisar',
    requestsToReviewAdmin: 'Tienes solicitudes del curso <curso> pendientes por revisar en la lista de solicitantes',
    suggestedSchedule: '<colaborador> te ha sugerido una calendarización del curso <curso>',
    requestReplacementCourse: '<colaborador> ha solicitado que seas su reemplazo en el curso <curso>',
    cancelledSubscription: '<colaborador> ha cancelado su inscripción al curso <curso>',
    courseRequestApproved: 'Tu supervisor ha autorizado tu solicitud al curso <curso>',
    courseRequestRejected: 'Tu supervisor ha rechazado tu solicitud al curso <curso>',
    replacementCourseAccepted: '<colaborador> ha aceptado tu reemplazo para el curso <curso>',
    replacementCourseRejected: '<colaborador> ha rechazado tu reemplazo para el curso <curso>',
    coursesToReview: 'Tienes solicitudes de cursos pendientes por revisar',
    replacementCourseExpired: 'Te informamos que tu solicitud de reemplazo del curso <curso> se ha vencido',
    courseStartDate: 'Tu curso <curso> inicia el <fecha>',
    courseStartDateInstructor: 'Tu curso <curso> en el cual eres instructor inicia el <fecha>',
    newAcademyCourses: '¡Hay cursos nuevos de Academy!',
    courseExpireDate: 'Tu curso <curso> caduca el <fecha>',
    courseExpired: 'Tu curso <curso> ha caducado',
    realesedSpaceEnrolledCourse: 'Se ha liberado un espacio en el curso <curso> y has sido inscrito',
    notSpaceWaitingList: 'Tu facilitador ha autorizado tu solicitud al curso <curso> pero por el momento no hay cupo y estás en la lista de espera',
    answerQuestionary: 'Te informamos que la encuesta del curso <curso> ha iniciado. Tienes hasta antes del <fecha> para contestarla.',
    courseHaveRegisteredWaiting: 'Te informamos que has sido inscrito al curso <curso>, para el que te encontrabas en la lista de espera. Ahora te encuentras formalmente inscrito',

    // Comunicación
    startEvent: 'Ha iniciado el evento <tipoEvento>: <evento>',
    endEvent: 'Ha finalizado el evento <tipoEvento>: <evento>',
    assignedToInterview: 'Has sido asignado para entrevistar a <entrevistado> en el evento <tipoEvento>: <evento>',
    scheduledConversation: 'Tu conversación del evento <evento> ha sido agendada para el día <fecha> a las <hora>',
    assignedDelegate: '<colaborador> te ha asignado como delegado de <tipoDelegado> en el evento <tipoEvento>: <evento>',
    unassignedDelegate: '<colaborador> te ha desasignado como delegado de <tipoDelegado> en el evento <tipoEvento>: <evento>',
    assignedToActivity: '<colaborador> te ha asignado como responsable de la actividad con el ID: <actividad>',
    acceptedActivity: '<responsable> ha aceptado la actividad con el ID: <actividad>',
    rejectedActivity: '<responsable> ha rechazado la actividad con el ID: <actividad>',
    advanceActivity: '<responsable> ha ingresado un avance a la actividad <actividad>',
    haveBeenAddedParticipant: '<colaborador> te ha añadido como participante a la actividad con el ID: <actividad>',
    haveBeenRemovedParticipant: '<colaborador> te ha eliminado como participante de la actividad con el ID: <actividad>',
    deletedActivity: '<colaborador> ha eliminado la actividad con el ID: <actividad>',
    concludedActivity: '<responsable> ha concluido la actividad con el ID: <actividad>',
    notFinishedActivity: 'Te recordamos que tienes actividades pendientes por concluir',
    remindFinishSurvey: 'Te recordamos terminar de contestar en el evento <tipoEvento>: <evento>',
    remindScheduleConversation: 'Te recordamos agendar tu conversación con <entrevistado> en el evento <tipoEvento>: <evento>',

    // Sueldos y Promociones
    postulateApproved: 'Tu postulación de <postulado> ha sido aprobada por <tercerNivel>',
    postulateRejected: 'Tu postulación de <postulado> ha sido rechazada por <tercerNivel>',
    pendingPostulations: 'Tienes postulaciones pendientes por revisar',
    resultsEvent: 'Revisa los resultados del evento <evento>',
    salariesEvent: 'Revisa los sueldos del evento <evento>',
    postulateEmployee: '¡Postula colaboradores para el evento <evento>!',
    timeToVote: '¡Es hora de votar en el evento <evento>!',

    // Reclutamiento
    requestRejectedManager: 'Te informamos que la solicitud de <colaborador> para el puesto <puesto> fue cancelada por el comité',
    requestApprovedManager: 'Te informamos que la solicitud de <colaborador> para el puesto <puesto> fue confirmada por el comité',
    requestRejectedSupervisor: 'Tu solicitud para el puesto <puesto> fue cancelada por el comité',
    requestApprovatedSupervisor: 'Tu solicitud para el puesto <puesto> fue confirmada por el comité ',
    voteDoubt: 'Te informamos que un miembro del comité realizó un voto en duda en la solictud de <colaborador> para el puesto <puesto>',
    requestPendingReview: 'Te informamos que tienes solicitudes pendientes por revisar',
    requestRejected: 'Te informamos que tu solicitud para el puesto <puesto> fue rechazada',
    requestCancelledManager: 'Te informamos que el supervisor <colaborador> ha cancelado su solicitud al puesto <puesto>',
    requestCancelledSupervisor: 'Tu solicitud al puesto <puesto> ha sido cancelada por el encargado',
    assignedManager: 'Te han asignado como encargado de solicitudes',
    deleteManager: 'Tu asignación como encargado de solicitudes ha finalizado',
    assignedCommittee: 'Te han asignado como miembro del comité de votaciones',
    deleteCommittee: 'Tu asignación como miembro del comité de votaciones ha finalizado',
    requestConcludedSupervisor: 'Tu solicitud al puesto <puesto> ha sido concluida por el encargado',
    requestApprovated: 'Te informamos que tu solicitud para el puesto <puesto> fue aprobada y enviada al comité para su revisión',
    requestVoteCommitte: 'Te informamos que una nueva solicitud ha iniciado su votación',

    // Expediente 360
    shedulePending: 'Tienes el horario pendiente por aprobar de <colaborador>',
    sheduleApproved: 'Tu supervisor ha aprobado tu horario',
    sheduleRejected: 'Tu supervisor ha rechazado tu horario',
    backupAssigned: '<colaborador> te ha asignado como su backup del <fechaInicio> al <fechaFin>',
    cancelledBackup: '<colaborador> ha cancelado la solicitud de backup',
    rejectedBackup: '<colaborador> ha rechazado tu solicitud como backup',
    contractExpiration: 'Te informamos que el contrato <contrato> de <colaborador> vencerá en <dias> días',
    jobRequestPending: 'Te informamos que tienes solicitudes de cambio de puesto pendientes por revisar',
    jobRequestRejected: 'Te informamos que tu supervisor rechazó tu solicitud de cambio de puesto',
    jobRequestApproved: 'Te informamos que tu supervisor aprobo tu solicitud de cambio de puesto',
    endBackup: 'El periodo de backup ha finalizado',

    // Centro de Ayuda
    myRequestHasBeenAssigned: 'Tu solicitud #<idreporte> ha sido asignada a <especialista>',
    myRequestHasBeenReassigned: 'Tu solicitud #<idreporte> ha sido reasignada a <especialista>',
    myRequestHasBeenPaused: 'Tu solicitud #<idreporte> ha sido pausada por <especialista>',
    myRequestHasBeenCanceled: 'Tu solicitud #<idreporte> ha sido cancelada por <especialista>',
    myRequestHasBeenClosed: 'Tu solicitud #<idreporte> ha sido cerrada por <especialista>',
    addedCommentsMyRequest: '<especialista> añadió comentarios en tu solicitud #<idreporte>',
    haveBeenAssignedRequest: 'Te han asignado una nueva solicitud #<idreporte>',
    haveBeenReassignedRequest: 'Te ha reasignado la solicitud #<idreporte>',
    addedCommentsRequest: 'Se han añadido comentarios a la solicitud #<idreporte>',
    requestEvaluated: '<colaborador> ha evaluado la atención de la solicitud #<idreporte>',
    requestReopened: 'Te han reabierto la solicitud #<idreporte>',
    configNonWorkingDaysMoment: 'Es momento de configurar los días no laborables de tu empresa'
  }
};
